<template>
  <div class="rkld">
    <div class="rkldRight">
      <div class="rkldRightContent">
        <!-- tabs导航 -->
        <el-tabs v-model="editableTabsValue" type="card">
          <el-tab-pane label="走访清单" name="1">
            <!--搜索框-->
            <div class="searchTj">
              <div class="searchTjHead">
                <span>查询条件</span>
                <!-- <el-button
                                    style="
                                        float: right;
                                        padding: 3px 0;
                                        color: #000;
                                    "
                                    type="text"
                                    @click.native="Resert"
                                >
                                    <i class="el-icon-refresh"></i>
                                    刷新页面
                                </el-button> -->
                <i
                  class="searchDomw"
                  @click="searchValue = !searchValue"
                  :class="
                    searchValue == true
                      ? 'el-icon-arrow-up'
                      : 'el-icon-arrow-down'
                  "
                ></i>
              </div>
              <el-form
                :model="form"
                class="searchTjContent"
                v-show="searchValue"
              >
                <div class="searchTjContentDiv">
                  <span class="searchTjContentDivSpan">服务类型</span>
                  <el-select
                    v-model="form.typeName"
                    placeholder="请选择服务类型"
                  >
                    <el-option
                      label="上门走访、探望"
                      value="上门走访、探望"
                    ></el-option>
                    <el-option label="信息服务" value="信息服务"></el-option>
                  </el-select>
                </div>
                <div class="searchTjContentDiv" v-show="searchValue">
                  <span class="searchTjContentDivSpan">用户类型</span>
                  <el-select
                    v-model="form.minzhengIndex"
                    placeholder="请选择用户类型"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in usertypeList"
                      :key="index"
                      :label="item.dictLabel"
                      :value="item.dictCode"
                    ></el-option>
                  </el-select>
                </div>
                <div class="searchTjContentDiv" v-show="searchValue">
                  <el-button type="primary" class="searchBtns" @click="query"
                    >查询</el-button
                  >
                </div>
                <div class="searchTjContentDiv" v-show="searchValue">
                  <el-button type="info" class="resetReach" @click="resert"
                    >清除条件</el-button
                  >
                </div>
                <!-- <div
                                    class="arrowDown"
                                    @click="showSearch"
                                    style="color: #000"
                                >
                                    <i class="el-icon-arrow-down"></i>
                                </div> -->
              </el-form>
            </div>
            <div class="searchButtonDiv" v-show="quanbu">
              <div class="searchButtonDivLeft">
                <el-button-group>
                  <el-button
                    icon="el-icon-plus"
                    class="openBtns"
                    type="primary"
                    @click="handleClick('分配')"
                    >分配</el-button
                  >
                  <el-button
                    icon="el-icon-close"
                    type="danger"
                    @click="batchDelete"
                    >批量删除</el-button
                  >
                </el-button-group>
              </div>
              <!-- 筛选按钮 -->
              <div class="searchButtonDiveRight">
                <el-button-group>
                  <el-button
                    type="primary"
                    class="dropRests"
                    icon="el-icon-refresh"
                    @click="resertTable"
                  ></el-button>
                  <!-- <el-button type="primary"> -->
                  <el-dropdown
                    class="dropdown"
                    trigger="click"
                    :hide-on-click="false"
                  >
                    <span class="el-dropdown-link">
                      <i
                        class="el-icon-s-grid el-icon--right"
                        style="color: #fff"
                      ></i>
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>
                        <template>
                          <el-checkbox-group
                            v-model="checkList"
                            :min="1"
                            @change="tableShow"
                          >
                            <el-checkbox label="序号">序号</el-checkbox><br />
                            <el-checkbox label="服务类型">服务类型</el-checkbox
                            ><br />
                            <el-checkbox label="用户类型">用户类型</el-checkbox
                            ><br />
                            <el-checkbox label="区域">区域</el-checkbox><br />
                            <el-checkbox label="开始时间">开始时间</el-checkbox
                            ><br />
                            <el-checkbox label="结束时间">结束时间</el-checkbox
                            ><br />
                            <el-checkbox label="走访进度">走访进度</el-checkbox
                            ><br />
                            <el-checkbox label="处理人">处理人</el-checkbox
                            ><br />
                            <el-checkbox label="操作">操作</el-checkbox><br />
                          </el-checkbox-group>
                        </template>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!-- </el-button> -->
                </el-button-group>
              </div>
            </div>
            <!--表单-->
            <div class="addForm">
              <el-table
                ref="multipleTable"
                :data="tableDate"
                tooltip-effect="dark"
                @selection-change="handleSelectionChange"
                :header-cell-style="{
                  background: '#e6e6e6',
                  color: '#000',
                }"
                border
              >
                <el-table-column
                  type="selection"
                  width="50"
                  align="center"
                  @selection-change="handleSelectionChange"
                >
                </el-table-column>
                <el-table-column
                  type="index"
                  width="70"
                  label="序号"
                  align="center"
                  v-if="no1"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="typeName"
                  label="服务类型"
                  align="center"
                  v-if="no2"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="minzhengIndex"
                  label="用户类型"
                  align="center"
                  show-overflow-tooltip
                  v-if="no3"
                >
                  <template slot-scope="scope">
                    <span
                      v-for="(item, index) in usertypeList"
                      :key="index"
                      v-if="scope.row.minzhengIndex == item.dictCode"
                      >{{ item.dictLabel }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  label="区域"
                  align="center"
                  prop="areaName"
                  show-overflow-tooltip
                  v-if="no4"
                >
                </el-table-column>
                <el-table-column
                  prop="startTime"
                  label="开始时间"
                  align="center"
                  show-overflow-tooltip
                  v-if="no5"
                >
                </el-table-column>
                <el-table-column
                  prop="endTime"
                  label="结束时间"
                  align="center"
                  show-overflow-tooltip
                  v-if="no6"
                >
                </el-table-column>
                <el-table-column
                  label="走访进度"
                  align="center"
                  show-overflow-tooltip
                  v-if="no7"
                >
                  <template slot-scope="scope">
                    <span
                      @click="visitLook('走访进度', scope.row)"
                      v-if="
                        scope.row.overtotal != null || scope.row.total != null
                      "
                    >
                      {{ scope.row.overtotal + "/" + scope.row.total }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="serverPersonName"
                  label="处理人"
                  align="center"
                  show-overflow-tooltip
                  v-if="no9"
                >
                </el-table-column>
                <el-table-column
                  label="操作"
                  align="center"
                  width="300"
                  v-if="no8"
                >
                  <template slot-scope="scope">
                    <el-link
                      :underline="false"
                      class="span_icon"
                      @click="handleClick('查看', scope.row)"
                      >查看</el-link
                    >
                    <el-link
                      :underline="false"
                      class="span_icon"
                      @click="handleClick('问题汇总', scope.row)"
                      >老人问题汇总</el-link
                    >
                    <el-link
                      :underline="false"
                      class="span_icon"
                      @click="handleClick('查看明细', scope.row)"
                      >查看明细</el-link
                    >
                    <el-link
                      :underline="false"
                      class="span_icon"
                      @click="deleteId(scope.row)"
                      >删除</el-link
                    >
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页 -->
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              ></el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 新增功能模态框 -->
    <div class="addFrom" v-if="dialogVisible">
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="990px"
        :before-close="handleClose"
      >
        <el-form
          ref="addForm"
          :model="addForm"
          :rules="addFormRules"
          label-width="140px"
          :disabled="dialogTitle == '查看'"
          v-if="dialogTitle == '分配' || dialogTitle == '查看'"
        >
          <el-form-item label="项目名称：" prop="projectName">
            <el-select
              v-model="addForm.projectName"
              placeholder="请选择服务类型"
              ref="proName"
              style="width: 100%"
              @change="changeType"
            >
              <el-option
                v-for="(item, index) in projectList"
                :key="index"
                :label="item.projectName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务类型：" prop="evaluateTypeId">
            <el-select
              v-model="addForm.evaluateTypeId"
              placeholder="请选择服务类型"
              style="width: 100%"
              disabled
              @change="visitShow"
            >
              <el-option
                v-for="(item, index) in servicelist"
                :key="index"
                :label="item.typeName"
                :value="item.id + ''"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户类型：" prop="minzhengIndex">
            <el-select
              v-model="addForm.minzhengIndex"
              placeholder="请选择老人类型"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in usertypeList"
                :key="index"
                :label="item.dictLabel"
                :value="item.dictCode"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="区域：">
            <el-row>
              <el-col :span="4">
                <el-form-item>
                  <el-select
                    v-model="addForm.provinceId"
                    :disabled="
                      normalInfo.orgLevel == 1 ||
                      normalInfo.orgLevel == 2 ||
                      normalInfo.orgLevel == 3 ||
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5
                    "
                    placeholder="请选择省"
                    @change="handleProvince"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in provinceList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4" :offset="1">
                <el-select
                  v-model="addForm.cityid"
                  placeholder="请选择市"
                  @change="handleCity"
                  :disabled="
                    normalInfo.orgLevel == 2 ||
                    normalInfo.orgLevel == 3 ||
                    normalInfo.orgLevel == 4 ||
                    normalInfo.orgLevel == 5
                  "
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in cityList"
                    :key="index"
                    :label="item.name"
                    :value="item.adcode"
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4" :offset="1">
                <el-select
                  :disabled="
                    normalInfo.orgLevel == 3 ||
                    normalInfo.orgLevel == 4 ||
                    normalInfo.orgLevel == 5
                  "
                  v-model="addForm.zoneid"
                  placeholder="请选择区"
                  @change="handleArea"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in areaList"
                    :key="index"
                    :label="item.name"
                    :value="item.adcode"
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4" :offset="1">
                <el-select
                  :disabled="
                    normalInfo.orgLevel == 4 || normalInfo.orgLevel == 5
                  "
                  v-model="addForm.streetid"
                  @change="streetChange"
                  placeholder="请选择街道"
                >
                  <el-option
                    v-for="(item, index) in streetList"
                    :key="index"
                    :label="item.addName"
                    :value="item.addCode"
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4" :offset="1">
                <el-select
                  :disabled="normalInfo.orgLevel == 5"
                  v-model="addForm.shequid"
                  placeholder="请选择社区"
                >
                  <el-option
                    v-for="item in communityList"
                    :key="item.id"
                    :label="item.address"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="开始时间：" prop="startTime">
            <el-date-picker
              v-model="addForm.startTime"
              :picker-options="pickerOptions0"
              type="datetime"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间：" prop="endTime">
            <el-date-picker
              v-model="addForm.endTime"
              type="datetime"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width: 100%"
              :picker-options="pickerOptions0"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="频次：" prop="frequency">
            <el-input
              v-model="addForm.frequency"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="间隔天数：" prop="intervals">
            <el-input
              v-model="addForm.intervals"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="探望时长："
            prop="visitDuration"
            v-if="showVisit"
          >
            <el-input
              v-model="addForm.visitDuration"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="选择部门：" prop="serverStationId">
            <el-select
              v-model="addForm.serverStationId"
              placeholder="请选择部门"
              style="width: 100%"
              @change="selectDepart"
            >
              <el-option
                v-for="(item, index) in departmentDate"
                :label="item.departmentName"
                :value="item.id"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择人员：" prop="serverPersonId">
            <el-select
              v-model="addForm.serverPersonId"
              placeholder="请选择人员"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in personIdOptions"
                :label="item.personName"
                :value="item.id"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <div v-if="dialogTitle == '老人问题汇总'">
          <el-button type="primary" @click="createExcel"
            >导出全部Excel</el-button
          >
          <el-table
            ref="visitDate"
            :data="visitDate"
            tooltip-effect="dark"
            @row-click="openDetails"
            highlight-current-row
            :header-cell-style="{
              background: '#e6e6e6',
              color: '#000',
            }"
            border
            style="margin-top: 20px"
          >
            <el-table-column
              type="index"
              width="70"
              label="序号"
              align="center"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="customerName"
              label="姓名"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="updateDate"
              label="反馈时间"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>

            <el-table-column
              prop="feedback"
              label="反馈内容"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="feedbackstate"
              label="是否解决"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.feedbackstate == 0">未完成</span>
                <span v-if="scope.row.feedbackstate == 1">已完成</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="300">
              <template slot-scope="scope">
                <el-link
                  :underline="false"
                  class="span_icon"
                  @click="problemLook(scope.row)"
                  >查看</el-link
                >
                <el-link
                  :underline="false"
                  class="span_icon"
                  v-if="scope.row.feedbackstate == 0"
                  @click="procedureStep(scope.row)"
                  >处理</el-link
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="query2.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total2"
          ></el-pagination>
        </div>

        <div v-if="dialogTitle == '查看明细'">
          <el-form label-width="100px" :model="detailsData" ref="detailsData">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="服务类型">
                  <el-select
                    v-model="detailsData.evaluateTypeId"
                    style="width: 100%"
                  >
                    <!-- <el-option
                                            v-for="(item, index) in servicelist"
                                            :key="index"
                                            :label="item.typeName"
                                            :value="{
                                                value: String(item.id),
                                                label: item.typeName,
                                            }"
                                        ></el-option> -->
                    <el-option
                      v-for="(item, index) in servicelist"
                      :key="index"
                      :label="item.typeName"
                      :value="item.id + ''"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="用户类型">
                  <el-select
                    v-model="detailsData.minzhengIndex"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in usertypeList"
                      :key="index"
                      :label="item.dictLabel"
                      :value="item.dictCode"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="区域">
                  <!-- <el-select v-model="detailsData.area" style="width: 100%">
                    <el-option value="0" label="农村"></el-option>
                    <el-option value="1" label="城市"></el-option>
                  </el-select> -->
                  <el-input v-model="detailsData.address"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="时间">
                  <el-date-picker
                    style="width: 100%"
                    v-model="detailsData.time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="频次">
                  <el-input
                    v-model="detailsData.frequency"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="间隔天数">
                  <el-input
                    v-model="detailsData.intervals"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="处理部门">
                  <el-select
                    v-model="detailsData.department"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in departmentDate"
                      :label="item.departmentName"
                      :value="item.id"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="处理人">
                  <el-select v-model="detailsData.handler" style="width: 100%">
                    <el-option
                      v-for="(item, index) in personIdOptions"
                      :label="item.personName"
                      :value="item.id"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-table
            ref="multipleTable"
            :data="visitDate"
            tooltip-effect="dark"
            @row-click="openDetails"
            highlight-current-row
            :header-cell-style="{
              background: '#e6e6e6',
              color: '#000',
            }"
            border
            style="margin-top: 20px"
          >
            <el-table-column
              type="index"
              width="70"
              label="序号"
              align="center"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="customerName"
              label="姓名"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="age"
              label="年龄"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="gender"
              label="性别"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span>{{ scope.row.gender == 0 ? "男" : "女" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="minzhengIndex"
              label="用户类型"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span
                  v-for="(item, index) in usertypeList"
                  :key="index"
                  v-if="scope.row.minzhengIndex == item.dictCode"
                  >{{ item.dictLabel }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="startTime"
              label="开始时间"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="endTime"
              label="结束时间"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              label="操作"
              fixed="right"
              align="center"
              width="200"
            >
              <template slot-scope="scope">
                <el-link
                  :underline="false"
                  class="span_icon"
                  @click="showInventory('查看', scope.row)"
                >
                  查看
                </el-link>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="query.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total1"
          ></el-pagination>
        </div>

        <div slot="footer" v-if="dialogTitle == '分配'">
          <el-button type="primary" :disabled="isdisabled" @click="save"
            >确定</el-button
          >
          <el-button @click="dialogVisible = false">取消</el-button>
        </div>
      </el-dialog>

      <!-- 进度 -->
      <el-dialog
        :title="dialogTitle1"
        :visible.sync="dialogVisible5"
        width="800px"
      >
        <!-- 信息回访进度 -->
        <div v-if="schedule">
          <el-table
            :data="tableDate1"
            tooltip-effect="dark"
            @row-click="openDetails"
            highlight-current-row
            :header-cell-style="{
              background: '#e6e6e6',
              color: '#000',
            }"
            style="width: 100%"
            border
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="customerName" label="姓名" align="center">
            </el-table-column>
            <el-table-column prop="age" label="年龄" align="center">
            </el-table-column>
            <el-table-column prop="gender" label="性别" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.gender == 1">男</span>
                <span v-if="scope.row.gender == 2">女</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="minzhengIndex"
              label="老人类型"
              align="center"
              min-width="200"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.minzhengIndex == 11"
                  >散居特困供养人员</span
                >
                <span v-if="scope.row.minzhengIndex == 8">农村留守老人</span>
                <span v-if="scope.row.minzhengIndex == 6"
                  >计划生育特殊家庭成员</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="visitTime"
              min-width="150"
              label="走访时间"
              align="center"
            >
            </el-table-column>
            <el-table-column label="走访进度" align="center">
              <template slot-scope="scope">
                <span>{{
                  scope.row.overtotalts + "/" + scope.row.totalts
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              fixed="right"
              align="center"
              width="200"
            >
              <template slot-scope="scope">
                <el-link
                  :underline="false"
                  class="span_icon"
                  @click="look2('查看', '信息回访', scope.row)"
                >
                  查看
                </el-link>
                <el-link
                  :underline="false"
                  class="span_icon"
                  @click="assign('指派', '信息回访', scope.row)"
                >
                  指派
                </el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>

      <el-dialog title="查看" :visible.sync="dialogVisible3" width="800px">
        <el-steps
          :active="stepIndex1"
          align-center
          v-show="stepIndex1 != 0"
          v-if="visitShow == true"
        >
          <el-step
            ><span slot="icon" @click="changeProgress(1)"
              >基本信息</span
            ></el-step
          >
          <el-step
            ><span slot="icon" @click="changeProgress(2)">{{
              currentVisitLookRow.evaluateTypeId == 26
                ? "信息服务"
                : "上门走访、探望"
            }}</span></el-step
          >
          <!-- <el-step
                        ><span slot="icon" @click="changeProgress(3)"
                            >上门走访、探望
</span
                        ></el-step
                    > -->
        </el-steps>
        <!-- 基本信息 -->
        <div
          class="dialog_content_pane"
          v-show="stepIndex1 == 1"
          v-if="visitShow == true"
        >
          <!-- :rules="formDateRules" -->
          <!-- v-show="stepIndex == 0 || stepIndex == 1" -->
          <el-form
            label-width="100px"
            :model="formData"
            ref="formData"
            :disabled="true"
          >
            <el-row>
              <el-col :span="24">
                <el-row
                  style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;
                  "
                >
                  <el-col :span="18">
                    <el-row class="dialog_form_left">
                      <el-col :span="11">
                        <el-form-item label="姓名：" prop="customerName">
                          <el-input
                            v-model="formData.customerName"
                            @blur="checkIdName"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11" :offset="1">
                        <el-form-item label="年龄：" prop="age">
                          <el-input v-model="formData.age" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11">
                        <el-form-item label="身份证号：" prop="idNumber">
                          <el-input
                            v-model="formData.idNumber"
                            @change="idCardchange"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11" :offset="1">
                        <el-form-item label="性别：" prop="gender">
                          <el-select
                            disabled
                            v-model="formData.gender"
                            placeholder="请选择性别"
                            style="width: 100%"
                          >
                            <el-option label="男" value="0"></el-option>
                            <el-option label="女" value="1"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11">
                        <el-form-item label="出生年月：" prop="birthday">
                          <el-date-picker
                            disabled
                            v-model="formData.birthday"
                            type="date"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            style="width: 100%"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11" :offset="1">
                        <el-form-item label="手机号：" prop="phone">
                          <el-input v-model="formData.phone"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col
                    :span="6"
                    style="
                      display: flex;
                      flex-direction: column;
                      align-items: flex-end;
                    "
                  >
                    <el-form-item prop="photo">
                      <div class="upImg">
                        <el-upload
                          :action="actionUrl"
                          :show-file-list="false"
                          :on-success="
                            (file, fileList) => {
                              handleAvatarSuccess(file, fileList, 'add')
                            }
                          "
                          :before-upload="beforeAvatarUpload"
                        >
                          <div class="avatar" v-if="imageUrl">
                            <img :src="imageUrl" />
                          </div>
                          <i
                            class="el-icon-plus avatar_uploader avatar-uploader-icon"
                            v-else
                          ></i>
                        </el-upload>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="民族：" prop="nation">
                  <el-select
                    v-model="formData.nation"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in nation"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="生活区域：" prop="lifeAreas">
                  <el-select
                    v-model="formData.lifeAreas"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option label="农村" value="1"></el-option>
                    <el-option label="城市" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="老人类别：" prop="type">
                  <el-select
                    v-model="formData.type"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option label="普通客户" :value="'1'"></el-option>
                    <el-option label="按康宝客户" :value="'2'"></el-option>
                    <el-option label="残联" :value="'3'"></el-option>
                    <el-option label="老干部" :value="'4'"></el-option>
                    <el-option label="计生委" :value="'5'"></el-option>
                    <el-option label="民政" :value="'6'"></el-option>
                    <el-option label="商业客户" :value="'7'"></el-option>
                    <el-option label="D类服务对象" :value="'8'"></el-option>
                    <el-option label="文明办" :value="'10'"></el-option>
                    <el-option label="军人事务局" :value="'13'"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="用户类型：" prop="minzhengIndex">
                  <el-select
                    v-model="formData.minzhengIndex"
                    placeholder="请选择用户类型"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in usertypeList"
                      :key="index"
                      :label="item.dictLabel"
                      :value="item.dictCode"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="居住地址：">
              <el-row>
                <el-col :span="4">
                  <el-form-item>
                    <el-select
                      v-model="formData.provinceId"
                      placeholder="请选择省"
                      @change="handleProvince"
                      :disabled="
                        normalInfo.orgLevel == 1 ||
                        normalInfo.orgLevel == 2 ||
                        normalInfo.orgLevel == 3 ||
                        normalInfo.orgLevel == 4 ||
                        normalInfo.orgLevel == 5
                      "
                      style="width: 100%"
                    >
                      <el-option
                        v-for="(item, index) in provinceList"
                        :key="index"
                        :label="item.name"
                        :value="item.adcode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="formData.cityid"
                    placeholder="请选择市"
                    @change="handleCity"
                    :disabled="
                      normalInfo.orgLevel == 2 ||
                      normalInfo.orgLevel == 3 ||
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5
                    "
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in cityList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    :disabled="
                      normalInfo.orgLevel == 3 ||
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5
                    "
                    v-model="formData.zoneid"
                    placeholder="请选择区"
                    @change="handleArea"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in areaList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="formData.streetid"
                    :disabled="
                      normalInfo.orgLevel == 4 || normalInfo.orgLevel == 5
                    "
                    placeholder="请选择街道"
                  >
                    <el-option
                      v-for="(item, index) in streetList"
                      :key="item.id"
                      :label="item.addName"
                      :value="item.addCode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    :disabled="normalInfo.orgLevel == 5"
                    v-model="formData.shequid"
                    placeholder="请选择社区"
                  >
                    <el-option
                      v-for="item in communityList"
                      :key="item.id"
                      :label="item.address"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-input
                v-model="formData.address"
                style="margin-top: 12px"
              ></el-input>
              <el-row :gutter="20" style="margin-top: 20px">
                <!-- <el-col :span="6">
                                    <div class="map_left">
                                        <p
                                            v-for="(item, index) in streetList"
                                            :key="index"
                                        >
                                            {{ item.name }}
                                        </p>
                                    </div>
                                </el-col> -->
                <el-col :span="24">
                  <div
                    class="map_right"
                    id="container1"
                    style="width: 100%; height: 400px"
                  ></div>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="居住情况：" prop="juzhuCommunity">
              <el-radio-group v-model="formData.juzhuCommunity">
                <el-radio label="4">独自居住</el-radio>
                <el-radio label="5">与配偶居住</el-radio>
                <el-radio label="3">与子女同住</el-radio>
                <el-radio label="6">其他</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="经济来源：" prop="economicSource">
              <el-checkbox-group v-model="formData.economicSource">
                <el-checkbox label="0">养老金</el-checkbox>
                <el-checkbox label="1">子女供养</el-checkbox>
                <el-checkbox label="2">救济优抚</el-checkbox>
                <el-checkbox label="3">兼职</el-checkbox>
                <el-checkbox label="4">其他</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="所属机构：" prop="serviceStation">
              <el-input v-model="formData.serviceStation"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <!-- <div
                    class="dialog_content_pane"
                    v-show="stepIndex1 == 1"
                    v-if="visitShow == true"
                >
                    <el-form
                        label-width="100px"
                        :model="formData"
                        ref="formData"
                        :disabled="dialogTitle == '查看'"
                    >
                        <el-row>
                            <el-col :span="24">
                                <el-row
                                    style="
                                        display: flex;
                                        align-items: center;
                                        margin-bottom: 20px;
                                    "
                                >
                                    <el-col :span="18">
                                        <el-row class="dialog_form_left">
                                            <el-col :span="11">
                                                <el-form-item
                                                    label="姓名："
                                                    prop="name"
                                                >
                                                    <el-input
                                                        v-model="formData.name"
                                                    ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="11" :offset="2">
                                                <el-form-item
                                                    label="年龄："
                                                    prop="idCode"
                                                >
                                                    <el-input
                                                        v-model="
                                                            formData.idCode
                                                        "
                                                    ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="11">
                                                <el-form-item
                                                    label="身份证号："
                                                    prop="idCard"
                                                >
                                                    <el-input
                                                        v-model="
                                                            formData.idCard
                                                        "
                                                    ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="11" :offset="2">
                                                <el-form-item label="性别：">
                                                    <el-select
                                                        v-model="formData.gender"
                                                        placeholder="请选择性别"
                                                        style="width: 100%"
                                                    >
                                                        <el-option
                                                            label="男"
                                                            value="1"
                                                        ></el-option>
                                                        <el-option
                                                            label="女"
                                                            value="2"
                                                        ></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="11">
                                                <el-form-item
                                                    label="出生年月："
                                                >
                                                    <el-date-picker
                                                        v-model="
                                                            addForm.birthday
                                                        "
                                                        type="date"
                                                        placeholder="选择日期"
                                                        value-format="yyyy-MM"
                                                        style="width: 100%"
                                                    >
                                                    </el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="11" :offset="2">
                                                <el-form-item label="手机号：">
                                                    <el-input
                                                        v-model="formData.phone"
                                                    ></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                    <el-col
                                        :span="6"
                                        style="
                                            display: flex;
                                            flex-direction: column;
                                            align-items: flex-end;
                                        "
                                    >
                                        <div class="upImg">
                                            <el-upload
                                                :action="actionUrl"
                                                :show-file-list="false"
                                                :on-success="
                                                    (file, fileList) => {
                                                        handleAvatarSuccess(
                                                            file,
                                                            fileList,
                                                            'add'
                                                        );
                                                    }
                                                "
                                                :before-upload="
                                                    beforeAvatarUpload
                                                "
                                            >
                                                <div
                                                    class="avatar"
                                                    v-if="imageUrl"
                                                >
                                                    <img :src="imageUrl" />
                                                </div>
                                                <i
                                                    class="el-icon-plus avatar_uploader avatar-uploader-icon"
                                                    v-else
                                                ></i>
                                            </el-upload>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-form-item label="民族：" prop="nation">
                            <el-select
                                v-model="formData.nation"
                                placeholder="请选择"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item in nation"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="生活区域：" prop="livingArea">
                            <el-select
                                v-model="formData.livingArea"
                                placeholder="请选择"
                                style="width: 100%"
                            >
                                <el-option label="农村" value="0"></el-option>
                                <el-option label="城市" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="用户类型：" prop="type">
                            <el-select
                                v-model="formData.type"
                                placeholder="请选择"
                                style="width: 100%"
                            >
                                <el-option label="民政" value="'6'"></el-option>
                                <el-option
                                    label="退役军人"
                                    value="'13'"
                                ></el-option>
                                <el-option label="残联" value="'3'"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="老人类别：" prop="oldType">
                            <el-select
                                v-model="formData.olderType"
                                placeholder="请选择老人类型"
                                style="width: 100%"
                            >
                                <el-option
                                    label="散居特困供养人员"
                                    value="11"
                                ></el-option>
                                <el-option
                                    label="农村留守老人"
                                    value="8"
                                ></el-option>
                                <el-option
                                    label="计划生育特殊家庭成员"
                                    value="9"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="居住地址：">
                            <el-row>
                                <el-col :span="4">
                                    <el-form-item>
                                        <el-select
                                            v-model="formData.shengId"
                                            placeholder="请选择省"
                                            @change="handleProvince"
                                            style="width: 100%"
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in provinceList"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.adcode"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-select
                                        v-model="formData.shiId"
                                        placeholder="请选择市"
                                        @change="handleCity"
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="(item, index) in cityList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-select
                                        v-model="formData.quId"
                                        placeholder="请选择区"
                                        @change="handleArea"
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="(item, index) in areaList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode + index"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-select
                                        v-model="formData.street"
                                        placeholder="请选择街道"
                                    >
                                        <el-option
                                            v-for="item in streetList"
                                            :key="item.id"
                                            :label="item.label"
                                            :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-select
                                        v-model="formData.community"
                                        placeholder="请选择社区"
                                    >
                                        <el-option
                                            v-for="item in communityList"
                                            :key="item.id"
                                            :label="item.label"
                                            :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                            <el-input
                                v-model="formData.address"
                                style="margin-top: 12px"
                            ></el-input>
                            <el-row :gutter="20" style="margin-top: 20px">
                                <el-col :span="6">
                                    <div class="map_left">
                                        <p
                                            v-for="(item, index) in streetList"
                                            :key="index"
                                        >
                                            {{ item.name }}
                                        </p>
                                    </div>
                                </el-col>
                                <el-col :span="16">
                                    <div
                                        class="map_right"
                                        id="container1"
                                        style="width: 100%; height: 300px"
                                    ></div>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-form>
                </div> -->

        <!-- 回访记录 -->
        <div class="dialog_content_pane" v-show="stepIndex1 == 2" v-if="true">
          <!-- 上门回访 -->
          <el-table
            ref="multipleTable"
            :data="scheduleData"
            tooltip-effect="dark"
            @row-click="openDetails"
            highlight-current-row
            :header-cell-style="{
              background: '#e6e6e6',
              color: '#000',
            }"
            border
          >
            <el-table-column
              type="index"
              width="70"
              label="序号"
              align="center"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="serverPersoName"
              label="探访人姓名"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="states"
              label="状态"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.states == 0">未完成</span>
                <span v-if="scope.row.states == 1">已完成</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="visitTime"
              label="探望时间"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              label="操作"
              fixed="right"
              align="center"
              width="200"
            >
              <template slot-scope="scope">
                <span class="span_icon" @click="look3('查看', scope.row)">
                  查看
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <div
            slot="footer"
            v-if="stepTitle != '走访探望'"
          >
            <el-button type="primary" @click="save1">确定</el-button>
            <el-button @click="dialogVisible4 = false">取消</el-button>
          </div> -->
      </el-dialog>

      <!-- 信息回访记录查看 -->
      <el-dialog title="查看" :visible.sync="dialogVisible10" width="990px">
        <el-form
          ref="returnVisitForm"
          class="return_visit_form"
          :model="returnVisitForm1"
          label-width="120px"
        >
          <template v-for="(item, index) in currentZfEvaluateContentLis">
            <div :key="index">
              <el-form-item label="问题：">
                <el-input
                  v-model="item.questionName"
                  placeholder="请输入问题"
                ></el-input>
              </el-form-item>
              <el-form-item label="回复选择：">
                <el-radio-group v-model="item.replySelection">
                  <el-radio label="0">是</el-radio>
                  <el-radio label="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="原因：" placeholder="请输入内容">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="item.reason"
                ></el-input>
              </el-form-item>
            </div>
          </template>
          <!--                     
                    <el-form-item label="问题：">
                        <el-input
                            v-model="returnVisitForm1[1].questionName"
                            placeholder="请输入问题"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="回复选择：">
                        <el-radio-group
                            v-model="returnVisitForm1[1].replySelection"
                        >
                            <el-radio label="0">是</el-radio>
                            <el-radio label="1">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="原因：" placeholder="请输入内容">
                        <el-input
                            type="textarea"
                            :rows="3"
                            v-model="returnVisitForm1[1].reason"
                        ></el-input>
                    </el-form-item> -->
          <el-form-item label="其他：" placeholder="请输入内容">
            <el-input type="textarea" :rows="3" v-model="feedback"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" style="margin-button: 10px">
          <el-button type="primary" @click="save1">确定</el-button>
          <el-button @click="dialogVisible4 = false">取消</el-button>
        </div>
      </el-dialog>

      <!-- 探望查看 -->
      <el-dialog title="查看" :visible.sync="dialogVisible11" width="800px">
        <!-- 探望内容 -->
        <div class="dialog_content_pane">
          <!-- 上门回访 -->
          <div>
            <table
              ref="print"
              border="1"
              :model="addForm1"
              cellspacing="0"
              cellpadding="0"
              style="border-collapse: collapse; text-align: center; width: 100%"
            >
              <tr style="height: 60px">
                <td colspan="8">农村特殊困难老年人走访、探望情况登记表</td>
              </tr>
              <tr style="height: 60px">
                <td colspan="2" width="25%" style="background: #e0d6e0">
                  被探访人姓名
                </td>
                <td colspan="2">
                  {{ addForm1.name }}
                  <!-- 李倾 -->
                </td>
                <td colspan="2" style="background: #e0d6e0">探访人姓名</td>
                <td colspan="2">
                  {{ addForm1.serverPersoName }}
                </td>
              </tr>
              <tr style="height: 60px">
                <td colspan="2" style="background: #e0d6e0; width: 50%">
                  探访时间
                </td>
                <td colspan="2" style="width: 50%">
                  {{ addForm1.visitTime }}
                  <!-- 2020-10-31 15:30 -->
                </td>
                <td colspan="2" style="background: #e0d6e0">探访地点</td>
                <td colspan="2">
                  {{ addForm1.address }}
                </td>
              </tr>
              <tr style="height: 100px">
                <td colspan="2" style="background: #e0d6e0">老人服务需求</td>
                <td colspan="6">
                  <el-checkbox-group v-model="addForm1.elderlyDemand">
                    <el-checkbox label="0">安全巡查</el-checkbox>
                    <el-checkbox label="1">生活资料</el-checkbox>
                    <el-checkbox label="2">文化娱乐</el-checkbox>
                    <el-checkbox label="3">精神慰藉</el-checkbox>
                    <el-checkbox label="4">其他服务</el-checkbox>
                  </el-checkbox-group>
                </td>
              </tr>
              <tr style="height: 100px">
                <td colspan="2" style="background: #e0d6e0">
                  探视活动情况记录
                </td>
                <td colspan="6">
                  {{ addForm1.visitingRecord }}
                </td>
              </tr>
              <tr style="height: 100px">
                <td colspan="2" style="background: #e0d6e0">健康状况</td>
                <td colspan="6">
                  {{ addForm1.health == 0 ? "有" : "无" }}
                </td>
              </tr>
              <tr style="height: 100px" v-if="addForm1.health == 0">
                <td colspan="2" style="background: #e0d6e0">老人自理类别</td>
                <td colspan="6">
                  <el-checkbox-group
                    v-model="addForm1.elderlyCategory"
                    style="font-size: 30px"
                  >
                    <el-checkbox label="0">自理</el-checkbox>
                    <el-checkbox label="1">失能</el-checkbox>
                    <el-checkbox label="2">半失能</el-checkbox>
                    <el-checkbox label="3">失智</el-checkbox>
                    <el-checkbox label="4">轻度依赖</el-checkbox>
                    <el-checkbox label="5">重度依赖</el-checkbox>
                    <el-checkbox label="6">不能自理</el-checkbox>
                  </el-checkbox-group>
                </td>
              </tr>
              <tr style="height: 100px" v-if="addForm1.health == 0">
                <td colspan="2" style="background: #e0d6e0">听力状况</td>
                <td colspan="6">
                  <el-radio-group type="kind" v-model="addForm1.hearingStatus">
                    <el-radio v-model="addForm.hearingStatus" label="0"
                      >良好</el-radio
                    >
                    <el-radio v-model="addForm.hearingStatus" label="1"
                      >一般</el-radio
                    >
                    <el-radio v-model="addForm.hearingStatus" label="2"
                      >很大声才能听见</el-radio
                    >
                    <el-radio v-model="addForm.hearingStatus" label="3"
                      >听不见</el-radio
                    >
                  </el-radio-group>
                </td>
              </tr>
              <tr style="height: 200px" v-if="addForm1.health == 0">
                <td colspan="2" style="background: #e0d6e0">病史</td>
                <td colspan="6">
                  <el-checkbox-group
                    v-model="addForm1.medicalHistory"
                    style="font-size: 30px"
                  >
                    <el-checkbox label="0">健康</el-checkbox>
                    <el-checkbox label="1">高血压</el-checkbox>
                    <el-checkbox label="2">糖尿病</el-checkbox>
                    <el-checkbox label="3">冠心病</el-checkbox>
                    <el-checkbox label="4">恶性肿瘤</el-checkbox>
                    <el-checkbox label="5">结核病</el-checkbox>
                    <el-checkbox label="6">肝炎</el-checkbox>
                    <el-checkbox label="7">脑卒中</el-checkbox>
                    <el-checkbox label="8">精神疾病</el-checkbox>
                    <el-checkbox label="9">脑血栓</el-checkbox>
                    <el-checkbox label="10">慢性阻塞性肺疾病</el-checkbox>
                    <el-checkbox label="11">慢性支气管炎</el-checkbox>
                    <el-checkbox label="12">帕金森综合症</el-checkbox>
                    <el-checkbox label="13">腰间盘突出</el-checkbox>
                    <el-checkbox label="14">心脏病</el-checkbox>
                    <el-checkbox label="15">肺气肿</el-checkbox>
                    <el-checkbox label="16">风湿病</el-checkbox>
                    <el-checkbox label="17">脑中风</el-checkbox>
                    <el-checkbox label="18">高脂血症</el-checkbox>
                    <el-checkbox label="19">哮喘</el-checkbox>
                    <el-checkbox label="20">意外伤害</el-checkbox>
                    <el-checkbox label="21">其他</el-checkbox>
                  </el-checkbox-group>
                </td>
              </tr>
              <tr style="height: 100px">
                <td colspan="2" style="background: #e0d6e0">图片</td>
                <td colspan="6">
                  <!-- {{name}} -->
                  <div style="height: 100px; width: 570px">
                    <el-image
                      style="width: 20%"
                      :src="addForm1.photo"
                    ></el-image>
                    <!-- src="https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg" -->
                  </div>
                </td>
              </tr>
              <tr style="height: 60px">
                <td colspan="2" style="background: #e0d6e0">
                  被走访、探望人满意度情况
                </td>
                <td colspan="6">
                  {{ addForm1.satisfied == 1 ? "不满意" : "满意" }}
                </td>
              </tr>
            </table>
            <el-button
              type="primary"
              style="display: block; margin: 20px auto"
              @click="dy"
              >打印</el-button
            >
          </div>
          <!-- <div v-if="!twnrShow">
                        <el-form
                            ref="returnVisitForm"
                            class="return_visit_form"
                            :model="returnVisitForm"
                            label-width="120px"
                        >
                            <template
                                v-for="(
                                    item, index
                                ) in currentZfEvaluateContentLis"
                            >
                                <div :key="index">
                                    <el-form-item label="问题：">
                                        <el-input
                                            v-model="item.questionName"
                                            placeholder="请输入问题"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item label="回复选择：">
                                        <el-radio-group
                                            v-model="item.replySelection"
                                        >
                                            <el-radio label="0">是</el-radio>
                                            <el-radio label="1">否</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item
                                        label="原因："
                                        placeholder="请输入内容"
                                    >
                                        <el-input
                                            type="textarea"
                                            :rows="3"
                                            v-model="item.reason"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                            </template>
                           
                            <el-form-item
                                label="其他："
                                placeholder="请输入内容"
                            >
                                <el-input
                                    type="textarea"
                                    :rows="3"
                                    v-model="feedback"
                                ></el-input>
                            </el-form-item>
                        </el-form>
                    </div> -->
        </div>
      </el-dialog>

      <el-dialog
        :title="stepState == true ? '处理' : '查看'"
        :visible.sync="olderVisible"
        width="990px"
      >
        <el-form
          ref="olderForm"
          :model="olderForm"
          label-width="140px"
          disabled
        >
          <el-form-item label="姓名：" prop="customerName">
            <el-input v-model="olderForm.customerName"></el-input>
          </el-form-item>
          <el-form-item label="反馈时间：" prop="updateDate">
            <el-input v-model="olderForm.updateDate"></el-input>
          </el-form-item>
          <el-form-item label="反馈内容：" prop="feedback">
            <el-input
              v-model="olderForm.feedback"
              type="textarea"
              :rows="3"
            ></el-input>
          </el-form-item>
        </el-form>
        <div>
          <el-form
            ref="dealForm"
            :model="dealForm"
            :rules="dealRules"
            label-width="140px"
          >
            <el-form-item label="处理结果：" prop="handles">
              <el-input
                v-model="dealForm.handles"
                :disabled="stepState == false"
                type="textarea"
                :rows="3"
              ></el-input>
            </el-form-item>
            <el-form-item label="上传图片：" prop="handlesPhoto">
              <!-- <el-upload
                                class="upload-demo"
                                :action="actionUrl"
                                :disabled="stepState == false"
                                :on-remove="
                                    (file, fileList) =>
                                        handleRemove(file, fileList)
                                "
                                :before-remove="beforeRemove"
                                :on-success="(data) => fileSuccess(data)"
                                multiple
                                :limit="9"
                                :file-list="dealImgs"
                            >
                                <el-button size="small" type="primary" :disabled="stepState == false"
                                    >点击上传</el-button
                                >
                            </el-upload> -->
              <div class="upImg">
                <el-upload
                  :action="actionUrl"
                  :disabled="stepState == false"
                  :show-file-list="false"
                  :on-success="
                    (file, fileList) => {
                      fileSuccess(file, fileList, 'add')
                    }
                  "
                  :before-upload="beforeAvatarUpload"
                >
                  <div class="avatar" v-if="dealForm.handlesPhoto">
                    <img :src="dealForm.handlesPhoto" />
                  </div>
                  <div v-else style="text-align: center; width: 178px">
                    <i
                      class="el-icon-plus avatar_uploader avatar-uploader-icon"
                    ></i>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item v-if="stepState == true">
              <el-button type="primary" size="mini" @click="saveDeal"
                >保存</el-button
              >
              <el-button type="info" size="mini" @click="cancleDeal"
                >取消</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <el-dialog
        title="查看"
        :visible.sync="inventoryVisible"
        width="990px"
        class="inventory"
      >
        <el-form ref="inventoryForm" :model="inventoryForm" label-width="190px">
          <el-form-item
            label="老人服务需求："
            prop="esElderlyDemand"
            style="margin-top: 15px"
          >
            <el-checkbox-group v-model="inventoryForm.esElderlyDemand" disabled>
              <el-checkbox label="0">安全巡视</el-checkbox>
              <el-checkbox label="1">生活照料</el-checkbox>
              <el-checkbox label="2">文化娱乐</el-checkbox>
              <el-checkbox label="3">精神慰藉</el-checkbox>
              <el-checkbox label="4">其他服务</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="探视活动情况记录: " prop="esVisitingRecord">
            <el-input
              v-model="inventoryForm.esVisitingRecord"
              disabled
              type="text"
            ></el-input>
          </el-form-item>
          <el-form-item label="健康状态: " prop="esHealth">
            <el-select
              v-model="inventoryForm.esHealth"
              disabled
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in headlthList"
                :key="index"
                :value="item.id"
                :label="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="老人自理类别：" prop="elderlyCategory">
            <el-radio-group v-model="inventoryForm.elderlyCategory" disabled>
              <el-radio label="0">自理</el-radio>
              <el-radio label="1">失能</el-radio>
              <el-radio label="2">半失能</el-radio>
              <el-radio label="3">失智</el-radio>
              <el-radio label="4">轻度依赖</el-radio>
              <el-radio label="4">重度依赖</el-radio>
              <el-radio label="4">不能自理</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="听力状况：" prop="hearingStatus">
            <el-radio-group v-model="inventoryForm.hearingStatus" disabled>
              <el-radio label="0">良好</el-radio>
              <el-radio label="1">一般</el-radio>
              <el-radio label="2">很大声才能听见</el-radio>
              <el-radio label="3">听不见</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="病史：" prop="medicalHistory">
            <el-checkbox-group v-model="inventoryForm.medicalHistory" disabled>
              <el-checkbox label="0">健康</el-checkbox>
              <el-checkbox label="6">肝炎</el-checkbox>
              <el-checkbox label="19">哮喘</el-checkbox>
              <el-checkbox label="1">高血压</el-checkbox>
              <el-checkbox label="2">糖尿病</el-checkbox>
              <el-checkbox label="3">冠心病</el-checkbox>
              <el-checkbox label="5">结核病</el-checkbox>
              <el-checkbox label="7">脑卒中</el-checkbox>
              <el-checkbox label="11">"脑血栓</el-checkbox>
              <el-checkbox label="14">心脏病</el-checkbox>
              <el-checkbox label="15">肺气肿</el-checkbox>
              <el-checkbox label="16">风湿病</el-checkbox>
              <el-checkbox label="17">脑中风</el-checkbox>
              <el-checkbox label="4">恶性肿瘤</el-checkbox>
              <el-checkbox label="8">精神疾病</el-checkbox>
              <el-checkbox label="18">高脂血症</el-checkbox>
              <el-checkbox label="20">意外伤害</el-checkbox>
              <el-checkbox label="9">慢性阻塞性肺疾病</el-checkbox>
              <el-checkbox label="10">慢性支气管</el-checkbox>
              <el-checkbox label="12">帕金森综合症</el-checkbox>
              <el-checkbox label="13">腰椎间盘突出</el-checkbox>
              <el-checkbox label="21">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="图片: " prop="visitPhoto">
            <img
              v-for="(item, index) in photoUrl"
              :key="index"
              class="imgurl"
              :src="item.visitPhoto"
            />
          </el-form-item>
          <el-form-item label="被走访、探望人满意度情况: " prop="esSatisfied">
            <el-select
              v-model="inventoryForm.esSatisfied"
              disabled
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in headlthList"
                :key="index"
                :value="item.id"
                :label="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="原因: " prop="reason">
            <el-input
              v-model="inventoryForm.reason"
              disabled
              type="text"
            ></el-input>
          </el-form-item>
          <el-form-item label="老人反馈: " prop="feedback">
            <el-input
              v-model="inventoryForm.feedback"
              disabled
              type="text"
            ></el-input>
          </el-form-item>

          <el-form-item style="text-align: center">
            <el-button type="info" @click="invencancel">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog title="指派" :visible.sync="assignVisible" width="990px">
        <el-form ref="assignForm" :model="assignForm" label-width="140px">
          <el-form-item label="选择部门：" prop="serverStationId">
            <el-select
              v-model="assignForm.serverStationId"
              placeholder="请选择部门"
              style="width: 100%"
              @change="selectDepart"
            >
              <el-option
                v-for="(item, index) in departmentDate"
                :label="item.departmentName"
                :value="item.id"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择人员：" prop="serverPersonId">
            <el-select
              v-model="assignForm.serverPersonId"
              placeholder="请选择人员"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in personIdOptions"
                :label="item.personName"
                :value="item.id"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button type="primary" @click="assignSave">确定</el-button>
          <el-button @click="assignVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import common from "../../../utils/common.js"
import request from "@/utils/request.js"
import AMap from "AMap" // 引入高德地图
import baseURL from "@/api/baseURL"
import { discriCard, chekCode, chekPhone } from "@/views/elderManage/util.js"
export default {
  data() {
    return {
      orgList: [],
      arrOrgList: [],
      myMap: null,
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        },
      },
      isdisabled: false,
      usertypeList: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      orgList: [],
      arrOrgList: [],
      headlthList: [
        { id: "1", vlaue: "否" },
        { id: "0", value: "有" },
      ],
      esSatisList: [
        { id: "1", vlaue: "否" },
        { id: "0", value: "有" },
      ],
      currentZfEvaluateContentLis: [],
      dialogVisible10: false,
      dialogVisible11: false,
      // 图片预览
      dialogImageUrl: "",
      // 上传图片地址
      photoUrl: [],
      actionUrl: baseURL + "/jjyl/controller/uploadController/info/uploadPhoto",
      imageUrl: "",
      dealForm: {
        handles: "",
        handlesPhoto: "",
      },
      dealImgs: [],
      dealRules: {
        handles: [
          {
            required: true,
            message: "处理内容",
            trigger: "blur",
          },
        ],
        handlesPhoto: [
          {
            required: true,
            message: "上传图片",
            trigger: "blur",
          },
        ],
      },
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      query2: {
        pageNo: 1,
        pageSize: 10,
      },
      // 表单验证
      addFormRules: {
        // 项目名称
        projectName: [
          {
            required: true,
            message: "请选择项目名称",
            trigger: "change",
          },
        ],
        // 服务类型
        evaluateTypeId: [
          {
            required: true,
            message: "请选择服务类型",
            trigger: "change",
          },
        ],
        // 老人类型
        minzhengIndex: [
          {
            required: true,
            message: "请选择老人类型",
            trigger: "change",
          },
        ],
        // orgName: [
        //     {
        //         required: true,
        //         message: "请选择组织机构",
        //         trigger: "change",
        //     },
        // ],

        // 开始时间
        startTime: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "change",
          },
        ],
        //  结束时间
        endTime: [
          {
            required: true,
            message: "请选择结束时间",
            trigger: "change",
          },
        ],
        // 间隔天数
        // intervals: [
        //     {
        //         required: true,
        //         message: "请输入间隔天数",
        //         trigger: "blur",
        //     },
        // ],
        // 频次
        frequency: [{ required: true, message: "请输入频次", trigger: "blur" }],
        // 探望时长
        visitDuration: [
          {
            required: true,
            message: "请输入探望时长",
            trigger: "blur",
          },
        ],
      },
      olderForm: {
        customerName: "",
        time: "",
        content: "",
      },
      tableId: "",
      selectedData: [],
      nation: [
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛南族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族",
      ],
      // 筛选数据功能按钮初始值
      checkList: [
        "序号",
        "服务类型",
        "用户类型",
        "区域",
        "开始时间",
        "结束时间",
        "走访进度",
        "处理人",
        "创建时间",
        "操作",
      ],

      // 表单测试数据
      tableDate: [],
      // 老人问题汇总
      visitDate: [
        // {
        //     name: "夏立根",
        //     feedbackTime: "2020-12-19 20:10",
        //     feedbackContent: "",
        //     solve: 1,
        // },
      ],
      // 回访进度
      scheduleData: [],
      addForm: {
        serviceType: "", //服务类型
        serviceDemand: [], //用户类型
        provinceId: "", //区域
        cityid: "", //区域
        zoneid: "", //区域
        streetid: "", //区域
        shequid: "", //区域
        startTime: "", //开始时间
        endTime: "", //结束时间
        frequency: "", //频次
        interval: "", //间隔天数
        visitDuration: "", //探望时长
        department: "", //选择部门
        person: "", //选择人员
        health: "",
        // serviceDemand: [],
        selfCare: [],
        hraring: "",
        case: [],
        evaluateTypeId: null,
        shengjiId: "",
        shijiId: "",
        qujiId: "",
        stationId: "",
        shequjiId: "",
      },

      // 筛选按钮
      no1: true,
      no2: true,
      no3: true,
      no4: true,
      no5: true,
      no6: true,
      no7: true,
      no8: true,
      no9: true,

      quanbu: true, // 搜素条件是否显示
      showVisit: false, // 探望时长显示与否

      currentPage: 1, //默认展示第一页
      total: 0, //总数据
      total1: 0, //总数据
      total2: 0, //总数据
      searchValue: true,
      showSlide: true,
      editableTabsValue: "1",
      tabIndex: 1,
      input: "",
      value: "",
      valueSq: "",
      multipleSelection: [],
      pageNo: 1,
      pageSize: 10,
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1,
      },
      feedback: "",
      // addForm: {
      //     health: "",
      //     serviceDemand: [],
      //     selfCare: [],
      //     hraring: "",
      //     case: [],
      // },
      addForm1: {
        health: "0",
      },
      // 搜索
      form: {
        type: "",
        evaluateTypeId: "",
        pageNo: 1,
        pageSize: 10,
      },
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible3: false,
      dialogVisible5: false,
      stepIndex1: 1,
      twnrShow: false,
      dialogTitle: "",
      dialogTitle1: "",
      stepTitle: "",
      schedule: false,
      gathid: "",
      minzheng: "",
      tableDate1: [],
      tableDate4: [
        {
          returnName: "李倾",
          age: "12",
          gender: "1",
          olderType: "老人类型",
          visitTime: "2020-10-05 15:30",
          returnStatus: "已完成",
        },
      ],
      returnVisitForm1: "",
      returnVisitForm: {
        // 回访
        questionName1: "",
        replySelection1: "",
        reason1: "",
        questionName2: "",
        replySelection2: "",
        reason2: "",
        other: "",
      },
      formData: {
        //基本信息
        customerName: "", //姓名
        gender: "", //性别
        phone: "", //联系方式
        idNumber: "", //身份证号
        age: "", //年龄
        birthday: "", // 出生年月
        minzhengIndex: "", //老人类型
        provinceId: "", //省
        cityid: "", //市
        zoneid: "", //区
        streetid: "", //街道
        shequid: "", //社区
        address: "", //居住地址
        photo: "", //图片
        nation: "", //民族
        juzhuCommunity: "", //居住情况
        economicSource: [], //经济来源
        serviceStation: "", //所属机构
        birthday: "",
      },
      provinceList: [], //省列表
      cityList: [], //市列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [], //社区列表
      olderVisible: false,
      inventoryVisible: false,
      inventoryForm: {
        elderlyDemand: [],
        elderlyCategory: "",
        health: "",
        visitingRecord: "",
        hearingStatus: [],
        medicalHistory: [],
        visitphoto: [],
      },
      detailsData: {
        serviceType: "",
        olderType: "",
        area: "",
        time: [],
        frequency: "",
        interval: "",
        department: "",
        handler: "",
        intervals: "",
      },
      projectList: [], //项目名称
      servicelist: [], //服务类型
      provinceList: [], //省列表
      cityList: [], //市列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [], //社区列表
      polygons: [],
      departmentDate: [], //部门列表
      personIdOptions: [], //人员列表
      assignForm: {
        //指派
        serverStationId: "",
        serverPersonId: "",
      },
      assignVisible: false,
      isMap: true,
      stepState: false,
      normalInfo: {},
    }
  },
  inject: ["reload"], //注入
  methods: {
    getusertypeList() {
      let query = {
        pageNum: 1,
        pageSize: 999,
        dictType: "visiting_user_type",
      }
      this.$http
        .request({
          url: "/rbac/system/dict/data/list",
          method: "get",
          params: query,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.rows != null) {
              this.usertypeList = res.rows
              this.usertypeList.forEach((item) => {
                item.dictCode = String(item.dictCode)
              })
            }
          }
        })
    },
    //导出excel
    createExcel() {
      this.request2({
        url: "/jjyl/admin/zfpgdContent/info/downloadExcel",
        method: "POST",
        excel: true,
        data: {
          pgdId: this.tableId,
          feedback: "1",
        },
        responseType: "blob",
      }).then((res) => {
        console.log("adsasd")
        if (res) {
          const blob = new Blob([res], {
            type: "application/vnd.ms-excel",
          })
          const fileName = "老人问题汇总.xls"
          const linkNode = document.createElement("a")
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none"
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)
          this.$message.success("导出表格成功")
        }
      })
    },
    handleRemove(type, file, fileList) {
      // this.dealForm.handlesPhoto.map((item, index) => {
      //     if (file.response != null) {
      //         if (item == file.response.content) {
      //             this.dealForm.handlesPhoto.splice(index, 1)
      //         }
      //     } else {
      //         if (item == file.url) {
      //             this.dealForm.handlesPhoto.splice(index, 1)
      //         }
      //     }
      // })
    },
    // 移除文件
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    // 文件上传成功
    fileSuccess(res, file, add) {
      this.dealForm.handlesPhoto = res.content
    },
    // 文件超出限制数量
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 9个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    loopNode(node, arr) {
      if (node.parent == null) {
        return arr
      } else {
        arr.push(node.data.orgId)
        this.loopNode(node.parent, arr)
      }
    },
    handleEditNodeClick(data, node) {
      const clickNode = this.$refs.tree.getNode(node)
      const arr = []
      this.loopNode(clickNode, arr)
      this.arrOrgList = arr
      let obj = common.organization(this.arrOrgList)
      this.$set(this.addForm, "orgId", data.orgId)
      this.$set(this.addForm, "parentId", data.parentId)
      this.$set(this.addForm, "orgType", data.orgType)
      this.$set(this.addForm, "orgName", data.label)

      this.$set(this.addForm, "qujiId", obj.qujiId)
      this.$set(this.addForm, "shengjiId", obj.shengjiId)
      this.$set(this.addForm, "shijiId", obj.shijiId)
      this.$set(this.addForm, "stationId", obj.stationId)
      this.$set(this.addForm, "shequjiId", obj.shequjiId)
      this.$refs["selectBoxRef"].handleClose()
    },
    //获取组织机构
    getOrg() {
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgById",
          method: "POST",
          data: { id: this.$store.state.info.orgId },
        })
        .then((res) => {
          if (res.code == 200) {
            // this.getProvince()
            this.normalInfo = res.content
          } else {
            this.$message.error(res.message)
          }
        })
    },
    async changeFirst() {
      console.log(
        this.normalInfo,
        "机构信息 normalInfo.orgLevel",
        this.provinceList
      )
      if (this.normalInfo.provinceId == 0) {
        this.normalInfo.provinceId = ""
      } else {
        this.normalInfo.provinceId = String(this.normalInfo.provinceId)
        let cityList = await this.getDistrict(this.normalInfo.provinceId)
        this.cityList = cityList.districtList
        console.log("城市", this.cityList)
      }
      if (this.normalInfo.cityId) {
        this.normalInfo.cityId = String(this.normalInfo.cityId)
        let areaList = await this.getDistrict(this.normalInfo.cityId)
        this.areaList = areaList.districtList
        console.log("社区", this.areaList)
      } else {
        this.normalInfo.cityId = ""
      }

      if (this.normalInfo.areaId) {
        this.normalInfo.areaId = String(this.normalInfo.areaId)
        let streetList = await this.getStreetList(this.normalInfo.areaId)
        this.streetList = streetList
        console.log("街道", this.streetList)
      } else {
        this.normalInfo.areaId = ""
      }
      if (this.normalInfo.streetId) {
        this.normalInfo.streetId = String(this.normalInfo.streetId)
        let communityList = await this.getCommityList(this.normalInfo.streetId)
        this.communityList = communityList
      } else {
        this.normalInfo.streetId = ""
      }

      if (this.normalInfo.communityId) {
        this.normalInfo.communityId = Number(this.normalInfo.communityId)
      } else {
        this.normalInfo.communityId = ""
      }

      this.addForm.provinceId = this.normalInfo.provinceId
      this.addForm.cityid = this.normalInfo.cityId
      this.addForm.zoneid = this.normalInfo.areaId
      this.addForm.streetid = this.normalInfo.streetId
      this.addForm.shequid = this.normalInfo.communityId

      this.$forceUpdate()
      // console.log(this.normalInfo, "机构信息",this.)
    },
    //街道地址列表
    getStreetList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/addressYpe/info/findList",
            method: "POST",
            data: {
              parentId: val,
              pageNo: 1,
              pageSize: -1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              this.streetList = res.content.list
              resolve(res.content.list)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 搜索条件
    showSearch() {
      this.searchValue = !this.searchValue
    },

    // 筛选功能按钮
    tableShow() {
      if (this.checkList.length > 0) {
        if (this.checkList.findIndex((obj) => obj == "序号") == -1) {
          this.no1 = false
        } else {
          this.no1 = true
        }
        if (this.checkList.findIndex((obj) => obj == "服务类型") == -1) {
          this.no2 = false
        } else {
          this.no2 = true
        }
        if (this.checkList.findIndex((obj) => obj == "用户类型") == -1) {
          this.no3 = false
        } else {
          this.no3 = true
        }
        if (this.checkList.findIndex((obj) => obj == "区域") == -1) {
          this.no4 = false
        } else {
          this.no4 = true
        }
        if (this.checkList.findIndex((obj) => obj == "开始时间") == -1) {
          this.no5 = false
        } else {
          this.no5 = true
        }
        if (this.checkList.findIndex((obj) => obj == "结束时间") == -1) {
          this.no6 = false
        } else {
          this.no6 = true
        }
        if (this.checkList.findIndex((obj) => obj == "走访进度") == -1) {
          this.no7 = false
        } else {
          this.no7 = true
        }
        if (this.checkList.findIndex((obj) => obj == "处理人") == -1) {
          this.no9 = false
        } else {
          this.no9 = true
        }
        if (this.checkList.findIndex((obj) => obj == "操作") == -1) {
          this.no8 = false
        } else {
          this.no8 = true
        }
      }
    },
    // 流程处理
    procedureStep(date) {
      this.stepState = true
      this.olderVisible = true
      this.dealImgs = []
      this.dealForm = { handles: "", handlesPhoto: "" }
      this.olderForm = date
    },
    //取消处理
    cancleDeal() {
      this.olderVisible = false
      this.stepState = false
      this.dealImgs = []
    },
    // 确认处理
    saveDeal() {
      let self = this
      this.$refs.dealForm.validate((valid) => {
        if (valid) {
          // console.log(this.dealForm, "我提交了")
          //
          let data = { ...self.dealForm }
          //data.handlesPhoto = data.handlesPhoto.toString()
          data.feedbackstate = 1
          data.id = this.olderForm.id
          this.$http
            .request({
              url: "/jjyl/admin/zfpgdContent/info/handleZfpgdQuestion",
              method: "POST",
              data: {
                ...data,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                this.$message.success(res.message)
                this.stepState = false
                this.olderVisible = false
                this.gather(this.con)
                this.$forceUpdate()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      })
    },
    // 问题汇总查看
    problemLook(date) {
      this.stepState = false
      this.olderVisible = true
      this.olderForm = date
      this.dealForm = date
      console.log(date)
    },

    // 部门列表
    async departmentlist() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        webfrom: "2",
        departmentStates: 0,
      }
      params = Object.assign({}, params)
      await request({
        url: "/jjyl/admin/department/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        this.departmentDate = res.content.list
        this.total = res.content.count
      })
    },

    // 选择人员
    selectDepart(val) {
      let params = {
        departmentId: val,
        webfrom: "2",
      }
      params = Object.assign({}, params)
      request({
        url: "/jjyl/admin/person/info/findPersonByDept",
        method: "POST",
        data: params,
      }).then((res) => {
        console.log(res)
        this.personIdOptions = res.content
      })
    },

    // 进度查看
    visitLook(val, date) {
      this.currentVisitLookRow = date
      this.dialogVisible5 = true
      this.dialogTitle1 = val
      this.schedule = true
      let params = {
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        pgdId: date.id,
      }
      params = Object.assign({}, params)
      request({
        url: "/jjyl/admin/zfCustomer/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        console.log(res)
        if (res.content != null) {
          this.tableDate1 = res.content.list
        } else {
          this.tableDate1 = []
        }
      })
    },
    //查看明细的查看
    showInventory(title, row) {
      this.inventoryVisible = true
      console.log(row.id)
      let params = {
        id: row.id,
      }
      params = Object.assign({}, params)
      request({
        url: "jjyl/admin/zfpgdContent/info/findList1",
        method: "POST",
        data: params,
      }).then((res) => {
        console.log(res.content.length, "0=-=-======")
        if (res.code == 200) {
          if (res.content[0] != null) {
            this.inventoryForm = res.content[0]
            // this.inventoryForm.esHealth = String(
            //     this.inventoryForm.esHealth
            // )
            if (this.inventoryForm.esElderlyDemand != null) {
              this.inventoryForm.esElderlyDemand =
                this.inventoryForm.esElderlyDemand.split(",")
            }
            if (this.inventoryForm.medicalHistory != null) {
              this.inventoryForm.medicalHistory =
                this.inventoryForm.medicalHistory.split(",")
            }
            if (this.inventoryForm.visitPhoto != null) {
              this.inventoryForm.visitPhoto =
                this.inventoryForm.visitPhoto.substring(
                  0,
                  this.inventoryForm.visitPhoto.lastIndexOf("_")
                )
              this.inventoryForm.visitPhoto =
                this.inventoryForm.visitPhoto.split("_")
              for (let i = 0; i < this.inventoryForm.visitPhoto.length; i++) {
                this.photoUrl.push({
                  visitPhoto: this.inventoryForm.visitPhoto[i],
                })
              }
              console.log(this.photoUrl, "this.photoUrl")
            }
          } else {
            this.inventoryForm = {}
          }
        }
      })
    },
    invencancel() {
      this.inventoryVisible = false
      this.inventoryForm = {}
      this.photoUrl = []
    },
    // 指派
    assign() {
      this.assignVisible = true
    },

    // 指派保存
    assignSave() {
      let params = {
        ...this.assignForm,
      }
      params = Object.assign({}, params)
      request({
        url: "/jjyl/admin/zfpgdContent/info/update",
        method: "POST",
        data: params,
      }).then((res) => {
        console.log(res)
        // if(res.content!=null){
        // this.tableDate1 = res.content.list;
        // }else{
        //   this.tableDate1=[];
        // }
      })
      this.assignVisible = false
    },

    // 进度查看
    progressCheck(date) {
      let params = {
        id: date.id,
      }
      params = Object.assign({}, params)
      request({
        url: "/jjyl/admin/zfpgdContent/info/getContentById",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code == 200) {
          console.log(res.content)
          if (res.content != null || res.content != "null") {
            this.formData = res.content
            if (res.content.zfpgdQuestionList.length > 0) {
              this.scheduleData = res.content.zfpgdQuestionList
            } else {
              this.scheduleData = []
            }
          }
          // console.log(this.formData,res.content.zfpgdQuestionList)
        }
      })
    },

    // 打印
    dy() {
      this.$print(this.$refs.print)
    },

    // 走访进度点击切换
    changeProgress(index) {
      this.stepIndex1 = index
    },

    // 探望查看
    look2(title, index, date) {
      console.log(title, index, date)
      // return;
      this.$http
        .request({
          url: "/jjyl/admin/zfpgdContent/info/findListbyOld",
          method: "POST",
          data: {
            pageSize: 10,
            pageNo: 1,
            evaluateTypeId: this.currentVisitLookRow.evaluateTypeId,
            oldId: date.id,
          },
        })
        .then((res) => {
          console.log(res, "哈哈哈")
          this.scheduleData = res.content
        })
      setTimeout(async () => {
        await this.$nextTick(() => this.loadmap("container1"))
      }, 30)
      this.dialogVisible3 = true
      this.visitShow = true
      request({
        url: "/jjyl/admin/zfCustomer/info/getById",
        method: "POST",
        data: {
          id: date.id,
        },
      }).then(async (res) => {
        if (res.code == 200) {
          this.formData = res.content
          let temp = JSON.stringify(this.formData)
          let jsonTemp = JSON.parse(temp)
          this.formData.type = String(res.content.type)
          this.formData.shequid = Number(res.content.shequid)
          if (!jsonTemp.provinceId) return
          let city = await this.getDistrict(jsonTemp.provinceId)
          this.cityList = city.districtList
          if (!jsonTemp.cityid) return
          let area = await this.getDistrict(jsonTemp.cityid)
          this.areaList = area.districtList
          if (!jsonTemp.zoneid) return
          let street = await this.getStreetList(jsonTemp.zoneid)
          this.streetList = street
          if (!jsonTemp.streetid) return
          let communityList = await this.getCommityList(jsonTemp.streetid)
          this.communityList = communityList
          // this.streetChange(jsonTemp.streetid, true)
        }
      })
      return

      // 走访探望

      if (date.visitTime != null) {
        this.stepTitle = "走访探望"
        this.twnrShow = true
        return
      }

      // 信息回访
      if (date.infoTime != null) {
        this.progressCheck(date)
        this.twnrShow = false
        return
      }
    },

    look3(title, data) {
      console.log(data)
      let _this = this
      if (this.currentVisitLookRow.evaluateTypeId == 26) {
        this.dialogVisible10 = true
        if (data.zfpgdQuestionList.length > 0) {
          this.currentZfEvaluateContentLis = data.zfpgdQuestionList
          return
        }
        _this.$http
          .request({
            url: "/jjyl/admin/zfevaluateType/info/getById",
            method: "POST",
            data: {
              id: 26,
              pageSize: 100,
              pageNo: 1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (res.content == null || res.content == "null") {
                this.currentZfEvaluateContentLis = []
                return
              }
              this.currentZfEvaluateContentLis =
                res.content.zfEvaluateContentList
              console.log(
                this.currentZfEvaluateContentLis,
                "this.currentZfEvaluateContentLis"
              )
            }
          })

        return
      } else {
        this.dialogVisible11 = true
        let params = {
          id: data.id,
        }

        params = Object.assign({}, params)
        request({
          url: "/jjyl/admin/zfpgdContent/info/getContentById",
          method: "POST",
          data: params,
        }).then((res) => {
          this.huodeId = res.content.id
          if (res.code == 200) {
            this.formData = res.content
            // delete ;
            this.formData.questionName = res.content.questionName
              ? res.content.questionName
              : []
            this.formData.type = res.content.type
            this.returnVisitForm1 = res.content.zfpgdQuestionList
            // console.log(this.returnVisitForm1, "returnVisitForm1");
            // this.returnVisitForm1[0] = this.returnVisitForm1[0]
            //     ? this.returnVisitForm1[0]
            //     : [];
            // this.returnVisitForm1[1] = this.returnVisitForm1[1]
            //     ? this.returnVisitForm1[1]
            //     : [];

            // if(res.content.zfpgdQuestionList.length !=0){
            //   let res = res.content.zfpgdQuestionList

            // }
            this.feedback = res.content.feedback
            this.addForm1 = res.content
            this.addForm1.birthday = res.content.birthday
            try {
              this.addForm1.elderlyDemand = res.content.elderlyDemand.split(",")
              this.addForm1.medicalHistory =
                res.content.medicalHistory.split(",")
              this.addForm1.elderlyCategory =
                res.content.elderlyCategory.split(",")
            } catch (err) {
              console.log(err)
            }

            console.log(this.addForm1)
          }
        })
      }
    },

    //加载地图
    loadmap(index) {
      let self = this
      return new Promise((resolve, reject) => {
        self.myMap = new AMap.Map(index, {
          resizeEnable: true,
          zoom: 18,
        })
        resolve()
      })
    },

    // 地址 start
    //获取省级
    async getProvince() {
      let province = await this.getDistrict()
      this.provinceList = province.districtList
    },
    //获取地址
    getDistrict(name = "中国") {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
            if (bounds) {
              try {
                self.myMap.remove(self.polygons)
              } catch (err) {
                console.log(err)
              }
              self.polygons = []
              for (let i = 0, l = bounds.length; i < l; i++) {
                self.polygon = new AMap.Polygon({
                  map: self.myMap,
                  strokeWeight: 1,
                  strokeColor: "#0091ea",
                  fillColor: "#80d8ff",
                  fillOpacity: 0.4,
                  path: bounds[i],
                })

                self.polygons.push(self.polygon)
              }
              try {
                self.myMap.add(self.polygons)
              } catch (err) {
                console.log(err)
              }
              // self.myMap.setFitView(); //地图自适应
            }
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },

    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.addForm.cityid = ""
      this.addForm.zoneid = ""
      this.addForm.streetid = ""
      this.addForm.shequid = ""
      this.formData.cityid = ""
      this.formData.zoneid = ""
      this.formData.streetid = ""
      this.formData.shequid = ""
      let city = await this.getDistrict(val)
      this.cityList = city.districtList
    },
    //市级地址发生改变
    async handleCity(val) {
      this.addForm.zoneid = ""
      this.addForm.streetid = ""
      this.addForm.shequid = ""
      this.formData.zoneid = ""
      this.formData.streetid = ""
      this.formData.shequid = ""
      this.areaList = []
      this.streetList = []
      let area = await this.getDistrict(val)
      this.areaList = area.districtList
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.addForm.streetid = ""
      this.addForm.shequid = ""
      this.formData.streetid = ""
      this.formData.shequid = ""
      // val = val.replace(/.$/, "");
      let streetList = await this.getStreetList(val)
      this.streetList = streetList
      console.log("111", this.streetList)
    },
    //街道地址发生变化
    async streetChange(val) {
      this.addForm.shequid = ""
      this.formData.shequid = ""
      let communityList = await this.getCommityList(val)
      this.communityList = communityList
      //  this.joinAddress()
    },
    handleCommunityChange(val) {
      this.$nextTick(() => {
        this.$forceUpdate()
        // this.joinAddress()
      })
    },
    // 身份证获取信息
    idCardchange(val) {
      console.log(val)
      // let obj = discriCard(val)
      // console.log(obj)
      //出生年月
      var birthday = ""
      if (val != null && val != "") {
        if (val.length == 15) {
          birthday = "19" + val.substr(6, 6)
        } else if (val.length == 18) {
          birthday = val.substr(6, 8)
        }
        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-")
      }
      this.formData.birthday = birthday
      // 性别
      if (val.length == 18) {
        if (val.charAt(16) % 2 == 0) {
          this.formData.gender = "1"
        } else {
          this.formData.gender = "0"
        }
      } else if (val.length == 15) {
        if (val.charAt(14) % 2 == 0) {
          this.formData.gender = "1"
        } else {
          this.formData.gender = "0"
        }
      } else {
        return ""
      }
      // 年龄
      var myDate = new Date()
      var month = myDate.getMonth() + 1
      var day = myDate.getDate()
      var age = myDate.getFullYear() - val.substring(6, 10) - 1
      if (
        val.substring(10, 12) < month ||
        (val.substring(10, 12) == month && val.substring(12, 14) <= day)
      ) {
        age++
      }
      this.formData.age = age
    },

    // 图片上传 start
    handleAvatarSuccess(res) {
      this.imageUrl = res.content
      this.addForm.img = res.content
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!")
        return
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!")
        return
      }
    },
    handlePicturePreview(file) {
      this.dialogVisible1 = true
      this.dialogImageUrl = file.url
    },
    // 图片上传 end

    // 探望时长
    visitShow(id) {
      console.log(id)
      if (id === 24) {
        this.showVisit = false
      }
      if (id === 26) {
        this.showVisit = true
      }
    },

    // 弹框关闭
    handleClose() {
      this.dialogVisible = false
      this.visitDate = []
    },

    // 批量删除
    batchDelete() {
      var that = this
      var val = this.selectedData
      if (val.length > 0) {
        this.$confirm("确认永久删除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            val.forEach(function (item, index) {
              request({
                url: "/jjyl/admin/zfpgdContent/info/deleteById",
                method: "POST",
                data: { id: item.id },
              })
            })
          })
          .then(() => {
            this.resert()
            this.$message({
              type: "success",
              message: "删除成功!",
            })
          })
      } else {
        this.$confirm("请选择要删除的项。", "提示")
      }
      this.$refs.multipleTable.clearSelection()
    },
    // 查询
    query() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        ...this.form,
        evaluateTypeId: this.form.evaluateTypeId.value,
      }
      params = Object.assign({}, params)
      request({
        url: "/jjyl/admin/zfpgdContent/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        console.log(res)
        if (res.code == 200) {
          // lifeAreas
          if (res.content.list.length) {
            res.content.list.forEach((item) => {
              if (item.address == null) {
                item.address = ""
              }
              item.areaName =
                item.sheng + item.shi + item.qu + item.zhen + item.address
            })
          }

          this.tableDate = res.content.list
          this.total = res.content.count
        } else {
          this.tableDate = []
        }
      })
    },

    // 获取社区名称
    streetTap(val, data) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    //获取地址
    getMaps(name = "中国") {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: true, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            // console.log(result.districtList[0], "信息")
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 保存
    save() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          if (!this.addForm.provinceId) {
            this.$message.warning("请选择省")
            return
          }
          if (!this.addForm.cityid) {
            this.$message.warning("请选择市")
            return
          }
          if (!this.addForm.zoneid) {
            this.$message.warning("请选择区")
            return
          }
          if (!this.addForm.streetid) {
            this.$message.warning("请选择街道")
            return
          }
          if (!this.addForm.shequid) {
            this.$message.warning("请选择社区")
            return
          }
          let obj = common.organization(
            this.arrOrgList,
            this.normalInfo.orgLevels
          )
          if (this.addForm.intervals == "") {
            this.addForm.intervals = 1
          }
          let params = {
            ...this.addForm,
            evaluateTypeId: this.addForm.evaluateType,
            serviceDemand: this.addForm.serviceDemand.toString(),
            selfCare: this.addForm.selfCare.toString(),
            case: this.addForm.case.toString(),
            qujiId: obj.qujiId,
            shengjiId: obj.shengjiId,
            shijiId: obj.shijiId,
            stationId: obj.stationId,
            shequjiId: obj.shequjiId,
            orgName: obj.orgName,
            orgId: obj.orgId,
          }
          params = Object.assign({}, params)
          request({
            url: "/jjyl/admin/zfpgdContent/info/insert",
            method: "POST",
            data: params,
          }).then((res) => {
            console.log(res)
            if (res.code == 200) {
              this.dialogVisible = false
              this.showlist()
              console.log(res.content.serverStationId)
            }
          })
        }
      })
    },

    // 弹窗
    handleClick(type, date) {
      var con = {}
      this.con = date
      this.$forceUpdate()
      if (type != "分配") {
        this.tableId = date.id
        this.gathid = date.id
        this.minzheng = date.minzhengIndex
      }
      this.dialogVisible = true
      this.dialogTitle = type
      this.isdisabled = false
      switch (type) {
        case "分配":
          this.addForm = {
            serviceType: "", //服务类型
            serviceDemand: [], //用户类型
            provinceId: "", //区域
            cityid: "", //区域
            zoneid: "", //区域
            streetid: "", //区域
            shequid: "", //区域
            startTime: "", //开始时间
            endTime: "", //结束时间
            frequency: "", //频次
            intervals: "", //间隔天数
            visitDuration: "", //探望时长
            department: "", //选择部门
            person: "", //选择人员
            health: "",
            // serviceDemand: [],
            selfCare: [],
            hraring: "",
            case: [],
            evaluateTypeId: null,
            shengjiId: "",
            shijiId: "",
            qujiId: "",
            stationId: "",
            shequjiId: "",
          }
          this.changeFirst()
          this.resetForm("addForm")

          break
        case "老人问题汇总":
          this.gather(date)
          break
        case "查看":
          this.look(date)
          break
        case "查看明细":
          this.look(date)
          break
      }
    },
    // end

    // 问题汇总
    gather(date) {
      let params = {
        pgdId: this.gathid,
        feedback: "1",
        pageNo: this.query2.pageNo,
        pageSize: this.query2.pageSize,
      }
      params = Object.assign({}, params)
      request({
        url: "/jjyl/admin/zfpgdContent/info/findListbyOld",
        method: "POST",
        data: params,
      }).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          if (res.content != null) {
            this.visitDate = res.content.list
            this.dealImgs = []
            this.total2 = res.content.count
          } else {
            this.visitDate = []
          }
        }
        // this.servicelist = res.content.list;
      })
    },

    // 查看
    look(date) {
      request({
        url: "/jjyl/admin/zfpgdContent/info/getById",
        method: "POST",
        data: {
          id: date.id,
          pageSize: this.query.pageSize,
          pageNo: this.query.pageNo,
          minzhengIndex: date.minzhengIndex,
        },
      }).then(async (res) => {
        let provinceName = ""
        let cityName = ""
        let zoneName = ""
        let streetName = ""
        // res.content.evaluateTypeId = res.content.evaluateTypeId + ""
        if (res.content.serverStationId) {
          this.selectDepart(res.content.serverStationId)
        }

        this.addForm = res.content
        this.addForm.evaluateTypeId = String(res.content.evaluateTypeId)
        // this.servicelist = res.content.list;
        this.detailsData = res.content
        this.detailsData.department = res.content.serverStationId
        this.detailsData.handler = res.content.serverPersonId
        let time = []
        time.push(res.content.startTime)
        time.push(res.content.endTime)
        this.detailsData.time = time

        // 地址回显
        // let temp = JSON.stringify(this.addForm)
        // let jsonTemp = JSON.parse(temp)
        let jsonTemp = { ...res.content }
        this.formData.type = String(res.content.type)
        this.addForm.streetid = String(jsonTemp.streetId)
        this.addForm.shequid = Number(jsonTemp.shequid)
        if (this.addForm.shequid == 0) {
          this.addForm.shequid = ""
        }
        if (!jsonTemp.provinceId) return
        let city = await this.getDistrict(res.content.provinceId)
        this.getMaps(res.content.provinceId).then((res) => {
          provinceName = res.name
        })
        this.cityList = city.districtList
        if (!jsonTemp.cityid) return
        let area = await this.getDistrict(jsonTemp.cityid)
        this.getMaps(res.content.cityid).then((res) => {
          cityName = res.name
        })
        this.areaList = area.districtList
        if (!jsonTemp.zoneid) return
        this.getMaps(res.content.zoneid).then((res) => {
          zoneName = res.name
          console.log(res, "res")
        })
        this.getMaps(res.content.zoneid).then((res) => {
          let leng = String(jsonTemp.streetId).charAt(
            String(jsonTemp.streetId).length - 1
          )

          streetName = res.districtList[leng].name
        })
        let street = await this.getStreetList(res.content.zoneid)
        this.streetList = street

        if (!jsonTemp.streetId) return
        let communityList = await this.getCommityList(jsonTemp.streetId)
        this.communityList = communityList
        console.log(this.communityList)
        this.$forceUpdate()

        this.addForm.streetid = String(res.content.streetId)
        this.detailsData.streetid = String(res.content.streetId)
        this.formData.streetid = String(res.content.streetId)
        let address = provinceName + cityName + zoneName + streetName
        // this.$nextTick(() => {
        //     this.detailsData.address = address
        // })

        this.$set(this.detailsData, "address", address)
        this.$forceUpdate()
        console.log(
          this.streetList,
          provinceName + cityName + zoneName + streetName,
          this.detailsData.address,
          "111获取信息"
        )
        if (!jsonTemp.streetid) return
        this.streetChange(jsonTemp.streetid, true)
      })
      this.lookDetail()
    },
    //查看明细
    lookDetail() {
      let params = {
        id: this.gathid,
        pageSize: this.query.pageSize,
        pageNo: this.query.pageNo,
        minzhengIndex: this.minzheng,
      }
      params = Object.assign({}, params)
      request({
        url: "/jjyl/admin/zfpgdContent/info/getByZfpgdId",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code == 200) {
          console.log(res.content)
          //this.showlist()
          this.visitDate = res.content.list
          this.total1 = res.content.count
        }
      })
    },
    // 删除
    deleteId(date) {
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          id: date.id,
        }
        params = Object.assign({}, params)
        request({
          url: "/jjyl/admin/zfpgdContent/info/deleteById",
          method: "POST",
          data: params,
        }).then((res) => {
          if (res.code == 200) {
            this.showlist()
            this.$message({
              type: "success",
              message: "删除成功!",
            })
          }
        })
      })
    },

    // 行点击选中
    openDetails(row, event, column, cell) {
      this.$refs.multipleTable.toggleRowSelection(row)
      this.row = row
      this.column = column
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows
    },

    handleSelectionChange(data) {
      this.selectedData = data
      console.log(this.selectedData)
    },
    // 重置
    resert() {
      this.form = {}
      this.showlist()
    },

    // 表单刷新
    resertTable() {
      this.showlist()
      this.checkList = [
        "序号",
        "服务类型",
        "用户类型",
        "区域",
        "开始时间",
        "结束时间",
        "走访进度",
        "处理人",
        "创建时间",
        "操作",
      ]
      this.tableShow()
      // this.form = {}
    },

    //首页列表页每页请求数据
    handleSizeChange(val) {
      this.pageSize = val
      this.showlist()
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success",
      })
    },
    //请求第几数据
    handleCurrentChange(val) {
      this.pageNo = val
      this.showlist()
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success",
      })
    },
    //查看明细
    handleSizeChange1(val) {
      this.query.pageSize = val
      this.lookDetail()
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success",
      })
    },
    //请求第几数据
    handleCurrentChange1(val) {
      this.query.pageNo = val
      this.lookDetail()
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success",
      })
    },
    //老人问题反馈
    handleSizeChange2(val) {
      this.query2.pageSize = val
      this.gather()
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success",
      })
    },
    //请求第几数据
    handleCurrentChange2(val) {
      this.query2.pageNo = val
      this.gather()
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success",
      })
    },
    // 保存
    save1() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.dialogVisible4 = false
        }
      })
    },

    // 刷新页面
    Resert() {
      this.reload()
    },
    // 表单重置
    resetForm(formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields()
      }
    },

    //查项目名称
    serviceList() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      request({
        url: "/jjyl/admin/zfevaluateType/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        console.log(res, "servicelist")
        this.projectList = res.content.list //项目名称
        this.servicelist = res.content.list
      })
    },
    //类型改变
    changeType(val) {
      this.$nextTick(() => {
        // let proName=this.$refs.proName.selected.label
        let params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
        request({
          url: "/jjyl/admin/zfevaluateType/info/findList",
          method: "POST",
          data: params,
        }).then((res) => {
          this.servicelist = res.content.list //项目名称
          this.servicelist.map((item) => {
            if (item.id == val) {
              console.log(item.typeName)
              this.addForm.evaluateTypeId = item.typeName
              this.addForm.evaluateType = item.id
            }
          })
        })
      })
    },
    // 表格列表
    showlist() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.pageNo,
      }
      params = Object.assign({}, params)
      request({
        url: "/jjyl/admin/zfpgdContent/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        console.log(res)
        if (res.code == 200) {
          if (res.content.list.length) {
            res.content.list.forEach((item) => {
              if (item.address == null) {
                item.address = ""
              }
              item.areaName =
                item.sheng + item.shi + item.qu + item.zhen + item.address
            })
          }
          this.tableDate = res.content.list
          this.total = res.content.count
        } else {
          this.tableDate = []
        }
      })
    },
  },
  created() {
    this.getOrg()
    this.serviceList()
    this.showlist()
    this.departmentlist()
    this.getProvince()
    this.getusertypeList()
  },
}
</script>
<style lang="less" scoped>
.rkld {
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
}

.rkldLeft {
  width: 234px;
  height: 100%;
  background: #37404f;
}

.rkldLeftLogo {
  background-color: rgb(55, 64, 79);
  height: 68px;
  width: 100%;
  display: flex;
  align-items: center;
  color: #ffffff;
}

.rkldLeftLogoImage {
  width: 39px;
  margin-left: 20px;
  margin-right: 10px;
}

.rkldRight {
  flex: 1;
  height: 100%;
  width: calc(100% - 266px);
  background-color: #ffffff;
}

.rkldRightHead {
  border-bottom: 1px solid #f5f5f5;
  width: 100%;
  background-color: #ececec;
  height: 69px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.mlIcon {
  height: 35px;
  width: 35px;
  font-size: 14px;
  margin-left: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 3px;
}

.mlIcon:hover {
  background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar {
  display: none !important;
}

.rkldRightHeadRight {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 15px;
}

.demo-form-inline {
  padding: 0 5%;
}

.btnform {
  text-align: center;
}

.bodymsg {
  width: 140px;
  height: 40px;
  background-color: #ffb404;
  color: #fff;
  text-align: center;
  line-height: 40px;
  border-radius: 2px;
  margin-top: 20px;
  cursor: pointer;
}

.switchpage {
  display: inline-block;
  margin-bottom: 10px;
}

.activesiwtch {
  background-color: #d6d7d8;
}

.rkldRightHeadRightLeft {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
}

.rkldRightHeadRightLeft img {
  margin-right: 5px;
}

.rkldRightContent {
  height: calc(100% - 70px);
  overflow-y: auto;
  margin: 20px;
}

.searchTj {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f1f2f6;
  box-shadow: 0 0 6px rgba(151, 151, 151, 0.16);
  overflow: hidden;
  border-radius: 4px;
  margin: 5px;
}

.searchTjHead {
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: rgb(0, 0, 0);
  border-color: rgb(217, 217, 217);
  padding: 6px 15px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.searchTjContent {
  padding: 15px 20px 0px 5px;
  border: 1px solid rgb(217, 217, 217);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.searchTjContentDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 40px;
  margin-bottom: 10px;
  border-radius: 4px;
}

.searchTjContentDivSpan {
  min-width: 58px;
  margin-right: 20px;
  font-size: 14px;
}

.searchTjContentDivInput {
  width: 20%;
  min-width: 196px;
}

/deep/ .arrowDown {
  width: 28px;
  height: 28px;
  background: #edf2f0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  bottom: -14px;
  transform: translate(-50%, 0px) 2s;
  border-radius: 50%;
  z-index: 2;
  cursor: pointer;
  // transition: 2s;
}

/deep/ .el-tabs__content {
  padding-bottom: 20px;
}

.searchButtonDiv {
  height: 54px;
  display: flex;
  margin-top: 14px;
  align-items: center;
  justify-content: space-between;
}

.searchButtonDivLeft {
  display: flex;
}
/deep/ .el-button {
  border-radius: 4px;
  padding: 0px 8px !important;
  border: none;
  height: 30px;
}

.el-button-group /deep/ .el-button--warning:last-child {
  border-left-color: rgba(255, 255, 255, 0.5);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/deep/ .el-pagination {
  margin-top: 10px;
}

/deep/ .el-submenu__title i {
  color: #fff;
}

.el-submenu /deep/ .el-menu-item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/deep/ .el-submenu__title {
  border-bottom: 1px solid #2c3342;
  background: rgb(55, 64, 79) !important;
}

/deep/ .el-menu-item {
  border-bottom: 1px solid #2c3342;
  background: rgb(55, 64, 79) !important;
}

/deep/ .el-submenu.is-active /deep/ .el-submenu__title {
  border-bottom: 1px solid rgb(55, 64, 79);
}

/deep/
  .el-tabs--card
  > .el-tabs__header
  /deep/
  .el-tabs__item.is-active.is-closable {
  color: #0e2d5f;
}

/deep/ .el-menu .is-active {
  color: rgb(255, 255, 255) !important;
  background-color: #437ae1 !important;
}

/deep/ .el-submenu {
  width: 234px !important;
}

/deep/ .el-menu-item:hover {
  color: rgb(255, 255, 255) !important;
  background-color: #437ae1 !important;
}

/deep/ .tabBtn {
  margin: 0px;
}

.rkld .el-menu-vertical-demo:not {
  background: rgb(55, 64, 79) !important;
}

/* 用来设置当前页面element全局table 选中某行时的背景色*/
/deep/ .el-table__body tr.current-row > td {
  background-color: #fafad2 !important;
  color: #000;
}
/deep/ .el-table tbody tr:hover > td {
  background-color: #fafad2 !important;
}

.mapleft {
  margin-left: 10px;
  width: 200px;
  height: 400px;
  overflow-y: auto;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  p {
    line-height: 42px;
    text-align: center;
  }
}
// 弹框样式
/deep/ .el-dialog {
  .el-dialog__header {
    border-bottom: 1px solid #e6e6e6;
  }
  .el-dialog__footer {
    background: #e6e6e6;
  }
  // 弹框步骤条样式
  .el-step__icon.is-text {
    border-radius: 5px;
  }
  .is-finish .el-step__icon {
    background: #409eff;
  }
  .el-step__icon {
    width: auto;
    padding: 15px 20px;
    color: #ffffff;
    cursor: pointer;
    border: none;
    background: #c0c4cc;
  }
  .el-step {
    height: 40px;
    margin-bottom: 24px;
  }
  .el-step.is-horizontal .el-step__line {
    top: 16px;
  }
}

// 上传图片
/deep/ .upImg {
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;

    img {
      width: 178px;
      height: 178px;
      margin-right: 13px;
    }
  }
}

/deep/ .span_icon {
  margin: 0 10px;
}
.inventory /deep/.el-dialog__body {
  padding-bottom: 1px;
}
.imgurl {
  width: 100px;
  height: 100px;
  margin-right: 15px;
}
</style>
